export default __webpack_public_path__ + "static/media/Ballroll_00205.4916e572.png";